import { siteStore } from "../store";

export const setSelectedProjectId = (projectId: string | null) => (siteStore.selectedProjectId = projectId);
